type FbqArgs = unknown[]

type FbqFunction = ((...args: FbqArgs) => void) & {
  callMethod?: (...args: FbqArgs) => void
  queue?: FbqArgs[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: FbqFunction
    _fbq?: FbqFunction
  }
}

export type PixelEventParams = {
  content_name?: string
  content_ids?: string[]
  content_type?: string
  value?: number
  currency?: string
}

const PIXEL_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

let isInitialized = false

function ensurePixelLoaded(): void {
  if (typeof window === 'undefined' || window.fbq) return

  const fbq: FbqFunction = function (...args: FbqArgs) {
    const instance = window.fbq as FbqFunction
    if (instance.callMethod) {
      instance.callMethod.apply(instance, args)
      return
    }
    instance.queue?.push(args)
  } as FbqFunction

  fbq.queue = []
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.push = fbq

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = PIXEL_SRC
  document.head.appendChild(script)
}

export function initMetaPixel(pixelId: string): void {
  if (typeof window === 'undefined' || isInitialized) return
  isInitialized = true

  ensurePixelLoaded()
  window.fbq?.('init', pixelId)
  window.fbq?.('track', 'PageView')
}

export function trackAddToCart(params: PixelEventParams): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', 'AddToCart', params)
}
